import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import Encargados from './Encargados';
import PagoEntrega from './PagoEntrega';
import LeafletMap from '../colonias/LeafletMap';

class Sucursal extends FormComponent {

  async componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'sucursal/one', saveUrl: 'sucursal/save', backUrl: '/Catalogo/Sucursales' },
      new Form([
        Form.Field('text', 'sucursal', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'sucursal_nombre', 'Sucursal', '', [Validators.required], 8),
        Form.Field('number', 'sucursal_cp', 'Código postal', '', [Validators.required], 6),
        Form.Field('autocomplete', 'sucursal_id_colonia', 'Colonia', '', [Validators.required], 6),
        Form.Field('text', 'sucursal_calle', 'Calle', '', [Validators.required], 8),
        Form.Field('number', 'sucursal_numero', 'Numero Exterior', '', [Validators.required], 4),
        Form.Field('time', 'sucursal_hora_apertura', 'Hora de Apertura', '', [Validators.required], 6),
        Form.Field('time', 'sucursal_hora_cierre', 'Hora de Cierre', '', [Validators.required], 6),
        Form.Field('text', 'sucursal_lat', 'Latitud', '', [], 6),
        Form.Field('text', 'sucursal_lon', 'Longitud', '', [], 6),
      ], ['Guardar'], 'Sucursal'), this.formData
    )
    if (this.props.match.params.id) {
      let preds = await this.LoadPreds()
      console.log(preds);
      this.setState({ sucursal: preds });
    }
  }

  formData = async (form, cp = null) => {
    var Res = await Http.get(`sucursal/form?${cp ? `cp=${cp}` : ``}`);
    console.log(Res.data);
    if (!Res.error) {
      var newForm = form;
      if (Res.data.colonias)
        newForm = Form.FieldOptions(form, 'sucursal_id_colonia', Res.data.colonias, 'id', 'colonia');

      newForm = Form.ValueChange(newForm, {
        sucursal_cp: this.cpChange,
      });
      return newForm;
    }
  }

  cpChange = async (field) => {
    console.log(field.Value)
    if (field.Value.toString().length === 5) {
      this.setState({ FormData: await this.formData(this.state.FormData, field.Value) });
    }
  }

  handleMapChange = (lat, lon) => {
    if (this.state.FormData) {
      const updatedForm = Form.Patch(this.state.FormData, {
        sucursal_lat: lat,
        sucursal_lon: lon
      });
      this.setState({ FormData: updatedForm });
    }
  }

  render() {
    const latField = this.state.FormData && this.state.FormData.Fields ? this.state.FormData.Fields.find(f => f.Name === 'sucursal_lat') : null;
    const lonField = this.state.FormData && this.state.FormData.Fields ? this.state.FormData.Fields.find(f => f.Name === 'sucursal_lon') : null;
    const lat = latField ? latField.Value : '';
    const lon = lonField ? lonField.Value : '';

    return (
      <div>
        <this.FormRender />
        {/* <div style={{ margin: '20px 0', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '10px' }}>
          <h4 style={{ marginBottom: '10px' }}>Ubicación Geográfica de la Sucursal (Arrastra el marcador para ajustar)</h4>
          <LeafletMap lat={lat} lon={lon} onChange={this.handleMapChange} />
        </div> */}
        <div>
          <Encargados />
        </div>
        <div>
          <PagoEntrega sucursal={this.state.sucursal || {}} onChange={(vals) => this.setState({ sucrusal: vals })} />
        </div>
      </div>
    )
  }
}

export default withRouter(Sucursal)
